import { render, staticRenderFns } from "./CreateClientFromProspect.vue?vue&type=template&id=23d72fb2&"
import script from "./CreateClientFromProspect.vue?vue&type=script&lang=js&"
export * from "./CreateClientFromProspect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports